import { Config, TokenHistoryLabel } from "kadow-jetpack-model";

export function checkCTAsAreComplete(jetpackConfig: Config | undefined | null) {
  let ctasAreOk = !!jetpackConfig?.ctas?.length;

  jetpackConfig?.ctas?.forEach((cta) => {
    switch (cta.id) {
      case TokenHistoryLabel.Google:
        if (!jetpackConfig?.socials?.googlePlaceId) {
          ctasAreOk = false;
        }
        break;

      case TokenHistoryLabel.Facebook:
        if (!jetpackConfig?.socials?.facebook) {
          ctasAreOk = false;
        }
        break;

      case TokenHistoryLabel.IGStory:
      case TokenHistoryLabel.Instagram:
        if (!jetpackConfig?.socials?.instagram) {
          ctasAreOk = false;
        }
        break;

      case TokenHistoryLabel.TikTok:
        if (!jetpackConfig?.socials?.tiktok) {
          ctasAreOk = false;
        }
        break;

      case TokenHistoryLabel.SnapChat:
        if (!jetpackConfig?.socials?.snapchat) {
          ctasAreOk = false;
        }
        break;

      case TokenHistoryLabel.Receipt:
        if (
          !jetpackConfig?.mn?.[0] &&
          !jetpackConfig?.mn?.[1] &&
          !jetpackConfig?.mn?.[2]
        ) {
          ctasAreOk = false;
        }
        break;

      case TokenHistoryLabel.TripAdvisor:
      case TokenHistoryLabel.Custom:
        if (!cta.customAction) {
          ctasAreOk = false;
        }
        break;

      case TokenHistoryLabel.CheckIn:
        if (!jetpackConfig?.cic) {
          ctasAreOk = false;
        }
        break;

      default:
        break;
    }
  });

  return ctasAreOk;
}
